import BasePolicy from '@/policies/BasePolicy.js';

export default class NotePolicy extends BasePolicy {
    viewAny(user) {
        return user.hasPermissionTo('view all notes');
    }

    view(user) {
        return user.hasPermissionTo('view a note');
    }

    create(user) {
        return user.hasPermissionTo('create a note');
    }

    update(user) {
        return user.hasPermissionTo('edit a note');
    }

    delete(user) {
        return user.hasPermissionTo('delete a note');
    }
}
